<template>
  <el-container class="fullheight" style="border: 1px solid #eee">
    <div>
      <el-aside class="fullheight" :width="width" v-show="asideShow">
        <fe-sys-type-tree
          class="fe-sys-type-tree"
          cat-id="5"
          highlight-current
          ref="ecoDataDicTree"
          :support-filter="supportFilter"
          :default-expand-all="isExpand"
          expand-on-click-node="false"
          @node-click="handleNodeClick"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span class="show-ellipsis" :title="node.label">{{ node.label }}</span>
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                <!-- <i class="el-icon-more" title="更多操作" /> -->
                <img src="@/assets/img/iconMore.png" class="iconMore" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-plus" :command="{ node: node, data, action: 'add' }">添加</el-dropdown-item>
                <el-dropdown-item icon="el-icon-edit" v-if="data.parentId != '0'" :command="{ node: node, data, action: 'edit' }">编辑</el-dropdown-item>
                <el-dropdown-item icon="el-icon-upload2" v-if="data.parentId != '0'" :command="{ node: node, data, action: 'import' }">导入</el-dropdown-item>
                <el-dropdown-item icon="el-icon-delete" v-if="data.parentId != '0' && data.isSystem == 0" :command="{ node: node, data, action: 'delete' }"
                  >删除</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </span>
        </fe-sys-type-tree>
      </el-aside>

      <div class="navbar-collapse" :style="navbarCollapseStyle" @click="asideShow = !asideShow">
        <div class="navbar-collapse-bg">
          <i
            class="navbar-collapse-arrow"
            :class="{
              'el-icon-arrow-left': asideShow,
              'el-icon-arrow-right': !asideShow
            }"
          ></i>
        </div>
      </div>

      <!-- 导入 -->
      <el-dialog :visible.sync="dialogImportVisible" title="导入" width="50%" append-to-body>
        <el-form ref="form" label-width="150px">
          <eco-form-item label="默认模板">
            <el-button size="small" type="primary" icon="el-icon-download" @click="downloadTemplate()">模板下载</el-button>
          </eco-form-item>
          <eco-form-item label="文件">
            <el-upload
              :action="importUrl"
              :http-request="importData"
              :before-upload="beforeUpload"
              :file-list="fileList"
              accept=".xls,.xlsx"
              :limit="1"
              :auto-upload="false"
              ref="upload"
            >
              <el-button size="small" icon="el-icon-upload">选择文件</el-button>
              <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件</div>
            </el-upload>
          </eco-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelConfirm()">取 消</el-button>
          <el-button type="primary" @click="submitImport" element-loading-text="拼命导入中" v-loading.fullscreen.lock="fullscreenLoading">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 添加分类 -->
      <eco-sidebar-dialog destroy-on-close width="28%" :title="title" :visible="dialogVisible" :before-close="handleClose" append-to-body>
        <el-form :model="sysType" data-vv-scope="editSysTypeForm" style="padding: 20px">
          <eco-form-item label="父节点" label-width="100px" v-if="!sysType.id">
            <eco-input v-model="parentSysType.name" autocomplete="off" validate="required" disabled></eco-input>
          </eco-form-item>
          <eco-form-item label="分类名称" label-width="100px">
            <eco-input v-model="sysType.name" autocomplete="off" validate="required"></eco-input>
          </eco-form-item>
          <eco-form-item label="分类Key" label-width="100px">
            <eco-input
              v-model="sysType.typeKey"
              v-pinyin="sysType.name"
              autocomplete="off"
              :validate="{ required: true, alpha_num: true }"
              placeholder="请输入key"
            />
          </eco-form-item>
          <!-- <eco-form-item label="类型" label-width="100px">
            <eco-radio
              v-model="sysType.struType"
              :options="[{ key: 0, value: '平铺'}, { key: 1, value: '树形' }]"
            />
          </eco-form-item> -->
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <fe-submit-button :url="saveSysTypeUrl" :model="sysType" scope-name="editSysTypeForm" @after-save-data="afterSaveData">{{
            $t('eip.common.save')
          }}</fe-submit-button>
        </div>
      </eco-sidebar-dialog>

      <!-- 编辑分类 -->
      <eco-sidebar-dialog destroy-on-close width="28%" :title="title" :visible="dialogVisibleEdit" :before-close="handleClose" append-to-body>
        <el-form :model="sysType" data-vv-scope="editSysTypeForm" style="padding: 20px">
          <eco-form-item label="父节点" label-width="100px" v-if="!sysType.id">
            <eco-input v-model="parentSysType.name" autocomplete="off" validate="required" disabled></eco-input>
          </eco-form-item>
          <eco-form-item label="分类名称" label-width="100px">
            <eco-input v-model="sysType.name" autocomplete="off" validate="required"></eco-input>
          </eco-form-item>
          <eco-form-item label="分类Key" label-width="100px">
            <eco-input
              :disabled="true"
              v-model="sysType.typeKey"
              v-pinyin="sysType.name"
              autocomplete="off"
              :validate="{ required: true, alpha_num: true }"
              placeholder="请输入key"
            />
          </eco-form-item>
          <!-- <eco-form-item label="类型" label-width="100px">
            <eco-radio
              v-model="sysType.struType"
              :options="[{ key: 0, value: '平铺'}, { key: 1, value: '树形' }]"
            />
          </eco-form-item> -->
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="dialogVisibleEdit = false">取 消</el-button>
          <fe-submit-button :url="saveSysTypeUrl" :model="sysType" scope-name="editSysTypeForm" @after-save-data="afterSaveData">{{
            $t('eip.common.save')
          }}</fe-submit-button>
        </div>
      </eco-sidebar-dialog>

      <!-- 添加数据字典 -->
      <eco-sidebar-dialog destroy-on-close width="28%" :title="dicTitle" :visible="dicDialogVisible" :before-close="handleClose" append-to-body>
        <el-form :model="dicData" data-vv-scope="editDic" style="padding: 20px">
          <eco-form-item label="项名称" label-width="80px">
            <eco-input v-model="dicData.name" autocomplete="off" validate="required"></eco-input>
          </eco-form-item>
          <eco-form-item label="项值" label-width="80px">
            <eco-input
              v-model="dicData.key"
              v-pinyin="dicData.name"
              autocomplete="off"
              :validate="{ required: true, alpha_num: true }"
              placeholder="请输入key"
            />
          </eco-form-item>
          <eco-form-item label="排序" label-width="80px">
            <eco-input v-model="dicData.sn" autocomplete="off"></eco-input>
          </eco-form-item>
          <eco-form-item label label-width="80px">当前数据字典中项值必须唯一</eco-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="dicDialogVisible = false">取 消</el-button>
          <fe-submit-button :url="saveDicDataUrl" :model="dicData" scope-name="editDic" @after-save-data="afterSaveDicData">{{
            $t('eip.common.save')
          }}</fe-submit-button>
        </div>
      </eco-sidebar-dialog>
      <!-- 编辑数据字典 -->
      <eco-sidebar-dialog destroy-on-close width="28%" :title="dicTitle" :visible="editDicDialogVisible" :before-close="handleCloseEdit" append-to-body>
        <el-form :model="editDicData" data-vv-scope="editDic2" style="padding: 20px">
          <eco-form-item label="项名称" label-width="80px">
            <eco-input v-model="editDicData.name" autocomplete="off"></eco-input>
          </eco-form-item>
          <eco-form-item label="项值" label-width="80px">
            <eco-input :disabled="true" v-model="editDicData.key" autocomplete="off" placeholder="请输入key" />
          </eco-form-item>
          <eco-form-item label="排序" label-width="80px">
            <eco-input v-model="editDicData.sn" autocomplete="off"></eco-input>
          </eco-form-item>
          <eco-form-item label label-width="80px">当前数据字典中项值必须唯一</eco-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="editDicDialogVisible = false">取 消</el-button>
          <fe-submit-button :url="saveDicDataUrl" :model="editDicData" scope-name="editDic2" @after-save-data="afterSaveDicData">{{
            $t('eip.common.save')
          }}</fe-submit-button>
        </div>
      </eco-sidebar-dialog>
    </div>
    <el-container>
      <el-scrollbar class="dic-data-scrollbar">
        <eco-tree
          :data="dicDatas"
          node-key="id"
          :props="defaultProps"
          :support-filter="false"
          :expand-on-click-node="false"
          :default-expand-all="isExpandDic"
          ref="dicDataTree"
          @node-click="handleNodeClick2"
        >
          <!-- 作用域插槽：插槽prop -->
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span class="show-ellipsis" :title="node.label"><span v-if="data.state === '1'" class="show-stop">(禁用)</span>{{ node.label }}</span>
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                <!-- <i class="el-icon-more" title="更多操作" /> -->
                <img src="@/assets/img/iconMore.png" class="iconMore" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-plus" :command="{ node: node, data, action: 'dicAdd' }">添加</el-dropdown-item>
                <el-dropdown-item icon="el-icon-edit" v-if="data.parentId != '-1'" :command="{ node: node, data, action: 'dicEdit' }">编辑</el-dropdown-item>
                <el-dropdown-item icon="el-icon-delete" v-if="data.parentId != '-1' && data.isSystem == 0" :command="{ node: node, data, action: 'dicDelete' }"
                  >删除</el-dropdown-item
                >
                <el-dropdown-item icon="el-icon-edit" v-if="data.parentId != '-1'" :command="{ node: node, data, action: 'dicEditFlow' }"
                  >更新上级</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </span>
        </eco-tree>
      </el-scrollbar>
      <div class="editPart" v-if="showEdit">
        <template v-if="showType == 'second'">
          <el-form :model="editDicData" data-vv-scope="editDic3">
            <eco-form-item label="项名称" label-width="80px">
              <eco-input v-model="editDicData.name" autocomplete="off"></eco-input>
            </eco-form-item>
            <eco-form-item label="项值" label-width="80px">
              <eco-input :disabled="true" v-model="editDicData.key" autocomplete="off" placeholder="请输入key" />
            </eco-form-item>
            <eco-form-item label="排序" label-width="80px">
              <eco-input v-model="editDicData.sn" autocomplete="off"></eco-input>
            </eco-form-item>
            <eco-form-item label="状态" label-width="100px">
              <eco-radio
                v-model="editDicData.state"
                :options="[
                  { key: '0', value: '启用' },
                  { key: '1', value: '禁用' }
                ]"
              />
            </eco-form-item>
            <eco-form-item label label-width="80px">当前数据字典中项值必须唯一</eco-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="showEdit = false">取 消</el-button>
            <fe-submit-button :url="saveDicDataUrl" :model="editDicData" scope-name="editDic3" @after-save-data="afterSaveDicData">{{
              $t('eip.common.save')
            }}</fe-submit-button>
          </div>
        </template>
        <template v-else>
          <el-form :model="sysType" data-vv-scope="editSysTypeForm" style="padding: 20px">
            <eco-form-item label="父节点" label-width="100px" v-if="!sysType.id">
              <eco-input v-model="parentSysType.name" autocomplete="off" validate="required" disabled></eco-input>
            </eco-form-item>
            <eco-form-item label="分类名称" label-width="100px">
              <eco-input v-model="sysType.name" autocomplete="off" validate="required"></eco-input>
            </eco-form-item>
            <eco-form-item label="分类Key" label-width="100px">
              <eco-input
                :disabled="true"
                v-model="sysType.typeKey"
                v-pinyin="sysType.name"
                autocomplete="off"
                :validate="{ required: true, alpha_num: true }"
                placeholder="请输入key"
              />
            </eco-form-item>
          </el-form>
          <div class="demo-drawer__footer">
            <el-button @click="dialogVisibleEdit = false">取 消</el-button>
            <fe-submit-button :url="saveSysTypeUrl" :model="sysType" scope-name="editSysTypeForm" @after-save-data="afterSaveData">{{
              $t('eip.common.save')
            }}</fe-submit-button>
          </div>
        </template>
      </div>
    </el-container>
    <div class="i_export">
      <el-button v-loading="loading" @click="iExport">下载</el-button>
    </div>

    <el-dialog class="hr-script-select" width="50%" title="更新上级" :visible.sync="switchDialog" :close-on-click-modal="false" append-to-body destroy-on-close>
      <div slot="title" class="dialog-header-title">
        <span class="name" style="font-weight: 600">更新上级</span>
      </div>
      <el-form :model="switchForm" :rules="switchRules" ref="switchRuleForm" label-width="114px" class="demo-ruleForm">
        <el-form-item prop="parentId" label="上级:">
          <el-cascader
            v-model="switchForm.parentId"
            :options="transTreeData"
            :props="{ checkStrictly: true, label: 'name', value: 'id', emitPath: false }"
            clearable
            filterable
          ></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveSwitch">保存</el-button>
        <el-button @click="clearableSwitchDialog">取消</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>
<script>
import form from '@/api/form.js'
import styles from '@/assets/css/element-variables.scss'
const EipSysTypeSelector = () => import('@/components/selector/EipSysTypeSelector.vue')
import portalApi from '@/api/portal.js'
const feSysTypeTree = () => import('@/components/common/FeSysTypeTree.vue')
export default {
  components: {
    EipSysTypeSelector,
    feSysTypeTree
  },
  props: {
    width: {
      type: String,
      default: styles.aside_width
    },
    supportFilter: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dicData: {
        key: '',
        name: '',
        parentId: '',
        typeId: ''
      },
      showEdit: false,
      editDicData: {
        state: '0'
      },
      dicParentId: '', //存储数据字典父类id用于刷新数据字典树
      title: '添加数据字典分类',
      dicTitle: '添加数据字典',
      asideShow: true,
      isExpand: true,
      isExpandDic: true,
      dialogVisible: false,
      dialogVisibleEdit: false,
      dicDialogVisible: false,
      editDicDialogVisible: false,
      dialogImportVisible: false,
      fullscreenLoading: false,
      fileList: [],
      sysType: {
        children: [],
        icon: '{}',
        isLeaf: 'N',
        struType: 0,
        typeKey: '',
        name: ''
      },
      parentSysType: {
        name: ''
      },
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      data: [],
      pageResult: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      bpmForm: {
        key: '',
        bos: '',
        desc: ''
      },
      dicDatas: [],
      loading: false,
      showType: 'first',
      switchDialog: false,
      transTreeData: [],
      switchForm: {},
      switchRules: {
        parentId: [{ required: true, message: '请选择移动到的上级' }]
      }
    }
  },
  computed: {
    formDeleteUrl: function () {
      return `${window.context.uc}/form/form/v1/remove`
    },
    navbarCollapseStyle: function () {
      if (this.asideShow) {
        return { left: parseInt(this.width) + 'px' }
      }
      return { left: '0px' }
    },
    saveSysTypeUrl: function () {
      return `${window.context.portal}/sys/sysType/v1/save?parentId=${this.parentSysType.id}&isRoot=${this.parentSysType.parentId == 0 ? 1 : 0}&isPriNode=0`
    },
    saveDicDataUrl: function () {
      return `${window.context.portal}/sys/dataDict/v1/save`
    },
    importUrl: function () {
      return window.context.portal + '/sys/dataDict/v1/import'
    }
  },
  mounted() {},
  methods: {
    formatTreeData(jsonData) {
      var result = [],
        temp = {},
        i = 0,
        j = 0,
        len = jsonData.length
      for (; i < len; i++) {
        temp[jsonData[i]['id']] = jsonData[i] // 以id作为索引存储元素，可以无需遍历直接定位元素
      }
      for (; j < len; j++) {
        var currentElement = jsonData[j]
        var tempCurrentElementParent = temp[currentElement['parentId']] // 临时变量里面的当前元素的父元素
        if (tempCurrentElementParent) {
          // 如果存在父元素
          if (!tempCurrentElementParent['children']) {
            // 如果父元素没有chindren键
            tempCurrentElementParent['children'] = [] // 设上父元素的children键
          }
          tempCurrentElementParent['children'].push(currentElement) // 给父元素加上当前元素作为子元素
        } else {
          // 不存在父元素，意味着当前元素是一级元素
          result.push(currentElement)
        }
      }
      return result
    },
    handleNodeClick(node, data) {
      this.showEdit = node.parentId != '0'
      this.dicLoadData(node.id)
      var newDicdata = {}
      this.title = '编辑数据字典分类'
      //克隆一个对象 以免数据与树动态绑定
      Object.assign(newDicdata, data.data)
      this.editDicData = newDicdata
      this.sysType = newDicdata
      this.showType = 'first'
    },
    handleNodeClick2(data, node) {
      this.showEdit = data.parentId != '-1'
      var newDicdata = {}
      this.title = '编辑数据字典分类'
      //克隆一个对象 以免数据与树动态绑定
      Object.assign(newDicdata, data)
      this.editDicData = newDicdata
      this.showType = 'second'
    },
    dicLoadData(id) {
      portalApi.getByTypeId(id).then((data) => {
        if (data) {
          //数据转换成树 children格式
          this.dicParentId = id
          this.dicDatas = this.formatTreeData(data)
          this.transTreeData = JSON.parse(JSON.stringify(this.dicDatas))
        }
      })
    },
    syncTree() {
      this.$refs.ecoDataDicTree.loadData()
    },
    syncDicTree() {
      if (this.dicParentId) {
        this.dicLoadData(this.dicParentId)
      }
    },
    handleExpand() {
      this.isExpand = !this.isExpand
      let elTree = this.$refs.ecoDataDicTree.$refs.ecoTree.$refs.elTree
      for (var i = 0; i < elTree.store._getAllNodes().length; i++) {
        elTree.store._getAllNodes()[i].expanded = this.isExpand
      }
    },
    handleExpandDic() {
      this.isExpandDic = !this.isExpandDic
      let elTree = this.$refs.dicDataTree.$refs.elTree
      for (var i = 0; i < elTree.store._getAllNodes().length; i++) {
        elTree.store._getAllNodes()[i].expanded = this.isExpandDic
      }
    },
    handleCommand(command) {
      let node = command.node
      let data = command.data
      let action = command.action
      switch (action) {
        case 'add':
          this.dialogVisible = true
          this.dicTypeAdd = true
          if (data) {
            this.sysType.id = ''
            this.sysType.name = ''
            this.sysType.typeKey = ''
            this.parentSysType = data
            this.sysType.parentId = data.id
            this.sysType.typeGroupKey = data.parentId == 0 ? data.typeKey : data.typeGroupKey
          }
          break
        case 'edit':
          var newDicdata = {}
          this.title = '编辑数据字典分类'
          //克隆一个对象 以免数据与树动态绑定
          Object.assign(newDicdata, data)
          this.sysType = newDicdata
          this.dialogVisibleEdit = true
          break
        case 'import':
          var newDicdata = {}
          Object.assign(newDicdata, data)
          this.sysType = newDicdata
          this.dialogImportVisible = true
          break
        case 'delete':
          if (data.id) {
            let this_ = this
            this.$confirm(`是否确定删除 [${data.name}]  及其子分类（包含分类下数据字典项数据）?`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              portalApi
                .delDataTypeDict(data.id)
                .then(
                  (resp) => {
                    let data = resp
                    if (data.state) {
                      this.$message({
                        type: 'success',
                        message: data.message || '删除成功'
                      })
                      this.$refs.ecoDataDicTree.loadData()
                      this.dicDatas = null
                      this.syncDicTree()
                    } else {
                      this.$message.error(data.message || '删除失败')
                    }
                  },
                  (error) => {
                    this.$message.error(error || '删除失败')
                  }
                )
                .catch(() => {
                  this.dialogVisible = false
                })
            })
          }
          break
        case 'dicAdd': //数据字典添加
          this.dicTitle = '添加数据字典'
          this.dicDialogVisible = true
          this.dicData.name = ''
          this.dicData.key = ''
          this.dicData.parentId = data.id
          this.dicData.typeId = data.typeId
          break
        case 'dicDelete':
          if (data.id) {
            this.$confirm(`是否确定删除 [${data.name}] ?`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              portalApi
                .delDataDict(data.id)
                .then(
                  (data) => {
                    if (data.state) {
                      this.$message({
                        type: 'success',
                        message: data.message || '删除成功'
                      })
                      this.syncDicTree()
                    } else {
                      this.$message.error(data.message || '删除成功')
                    }
                  },
                  (error) => {
                    this.$message.error(error || '删除失败')
                  }
                )
                .catch(() => {
                  this.dicDialogVisible = false
                })
            })
          }
          break
        case 'dicEdit':
          var newDicdata = {}
          this.dicTitle = '编辑数据字典'
          //克隆一个对象 以免数据与树动态绑定
          Object.assign(newDicdata, data)
          this.editDicData = newDicdata
          this.editDicDialogVisible = true
          break
        case 'dicEditFlow':
          this.dicTitle = '移动数据字典'
          //克隆一个对象 以免数据与树动态绑定
          this.switchForm = Object.assign({}, data)
          this.switchDialog = true
          break
        default:
          break
      }
    },
    handleClose() {
      this.dialogVisible = false
      this.dialogVisibleEdit = false
      this.dicDialogVisible = false
    },
    handleCloseEdit() {
      this.editDicDialogVisible = false
    },
    afterSaveData() {
      this.$refs.ecoDataDicTree.loadData()
      if (this.sysType.id) {
        this.dialogVisible = false
        return
      }
      this.sysType.name = ''
      this.sysType.typeKey = ''
      this.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      })
        .then(() => {})
        .catch(() => {
          this.dialogVisible = false
          this.dialogVisibleEdit = false
        })
    },
    afterSaveDicData() {
      if (this.dicParentId) {
        this.dicLoadData(this.dicParentId)
      }
      if (this.dicData.id) {
        this.dicDialogVisible = false
        return
      }
      this.dicData.name = ''
      this.dicData.key = ''
      this.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      })
        .then(() => {})
        .catch(() => {
          this.dicDialogVisible = false
          this.showEdit = true
        })
    },
    //导入
    importData(param) {
      let formData = new FormData()
      formData.append('file', param.file)
      portalApi
        .importDataDict(formData, this.sysType.id)
        .then((data) => {
          this.fullscreenLoading = false
          if (data.state) {
            this.$message({ type: 'success', message: data.message })
            param.onSuccess()
            this.dialogImportVisible = false
            this.dicLoadData(this.sysType.id)
            this.$refs.upload.clearFiles()
            this.fileList = []
          } else {
            this.$message.error(data.message)
            param.onError()
          }
        })
        .catch(() => {
          this.fullscreenLoading = false
        })
    },
    beforeUpload(file) {
      this.fullscreenLoading = true
    },
    submitImport() {
      if (!this.$refs.upload.uploadFiles || this.$refs.upload.uploadFiles.length == 0) {
        this.$message.warning('请上传数据字典文件进行导入')
        return false
      }
      if (this.sysType.id && this.sysType.id == '') {
        this.$message.warning('请选择某一个分类进行导入!')
      }
      this.$refs.upload.submit()
    },
    cancelConfirm() {
      this.$refs.upload.clearFiles()
      this.fileList = []
      this.dialogImportVisible = false
    },
    //下载模板
    downloadTemplate() {
      window.location.href = '/static/excel/数据字典模板.xls'
    },
    iExport() {
      this.loading = true
      this.$http.get('${portal}/sys/dataDict/v1/export', 'arraybuffer').then((resp) => {
        this.loading = false
      })
    },
    saveSwitch() {
      if (this.switchForm.id === this.switchForm.parentId) {
        return this.$message.error('不能选择自己作为父级')
      }
      this.$refs.switchRuleForm.validate((valid) => {
        if (valid) {
          this.$confirm(`是否确定更新?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$http
              .post(this.saveDicDataUrl, this.switchForm)
              .then((resp) => {
                if (resp.data.state) {
                  this.$message.success(resp.data.message || '更新成功')
                  this.syncDicTree()
                  this.clearableSwitchDialog()
                } else this.$message.error(resp.data.message || '更新失败')
              })
              .catch(() => {
                this.clearableSwitchDialog()
              })
          })
        }
      })
    },
    clearableSwitchDialog() {
      this.switchDialog = false
      this.switchForm = {}
    }
  }
}
</script>

<style lang="scss" scoped>
.el-main {
  padding: 0px;
}
>>> .navbar-collapse {
  position: absolute;
  top: 41%;
  cursor: pointer;
  z-index: 999;
  width: 20px;
}

>>> .el-dropdown {
  display: none;
}

>>> .el-tree-node__content:hover .el-dropdown {
  display: inline-block;
}

>>> .navbar-collapse:hover {
  transform: scale(1.1) translateY(2px);
}

>>> .navbar-collapse:hover .navbar-collapse-arrow {
  color: #333333;
}

>>> .navbar-collapse-arrow {
  position: absolute;
  top: 38%;
  right: -3px;
  font-size: 18px;
  color: #a8a8a8;
}

>>> .navbar-collapse-bg {
  -webkit-transition: all 0.12s ease;
  height: 50px;
  border-bottom: 8px solid transparent;
  border-right: none;
  border-left: 12px solid #ebebeb;
  border-top: 8px solid transparent;
  opacity: 0.9;
}
.el-aside-footer {
  position: absolute;
  bottom: 21px;
}
.i_export {
  position: absolute;
  top: 15px;
  right: 15px;
}
>>> .custom-tree-node {
  width: calc(100% - 40px);
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.custom-tree-node i {
  visibility: hidden;
  font-weight: bold;
}

.custom-tree-node:hover i {
  visibility: visible;
}

.dic-data-scrollbar {
  height: 100%;
  width: 450px;
  border-right: 1px solid #eee;
  /deep/.el-tree {
    width: inherit;
  }
}

.dic-data-scrollbar >>> .el-scrollbar__wrap {
  overflow-x: hidden;
}
.dic-data-scrollbar >>> .el-scrollbar__view {
  //display: flex;
  //height: 100%;
}
.editPart {
  width: 100%;
  height: calc(100% - 40px);
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 40px;
}
.show-stop {
  color: red;
  margin: 0 2px;
}
</style>
